export const desc = {
  project: {
    projectStatusAll:
      "Breakdown of funded project statuses across all funds. Manipulate the amount request/distributed for a various range of projects, set the rating of proposals to view in that range, and group the projects by different completion statuses (from 'not yet started' to 'launched'). See definitions for more details.",
    projectStatusFund:
      "Breakdown of funded project statuses across challenges. Manipulate the amount request/distributed for a various range of projects, set the rating of proposals to view in that range, and group the projects by different completion statuses (from 'not yet started' to 'launched'). See definitions for more details.",
    compledCounts:
      "Number of projects completed displayed in various time intervals. Track all completed projects over time, across both funds and challenges. Data can be displayed cumulatively or discretely in each time interval. ",
  },

  twitter: {
    wordCloud:
      "Word Cloud is used to visualize the most popular words, tags, or phrases given a particular platform, date range and collection of topics.",
    distribution:
      "One can visualize distribution for likes of the tweets, number of tweets for a particular keyword or account",
    sentiment:
      "Analysing tweets sentient can help quantify the number percentage of overall sentiment for each of the category",
    yearAnalysis:
      "Yearly analysis showing properties such as average likes, number of tweets  etc can determine trends over years",
    monthAnalysis:
      "Monthly analysis showing properties such as average likes, number of tweets  etc can determine trends within a partiucular year",
    interestOverTime:
      "Compare different user accounts in terms of their activity over time on social media to determine thier activity, likability etc",
    propertyBarYear:
      "Compare overall statistics such as average likes, number of tweets  etc for different sgements",
    dataPropertyScatter:
      "Forum data time series plot to see list of points of discussion in a date range.",
  },
  reddit: {
    wordCloud:
      "Word Cloud is used to visualize the most popular words, tags, or phrases given a particular platform, date range and collection of topics.",
    distribution:
      "One can visualize distribution for likes of the tweets, number of tweets for a particular keyword or account",
    sentiment:
      "Analysing tweets sentient can help quantify the number percentage of overall sentiment for each of the category",
    yearAnalysis:
      "Yearly analysis showing properties such as average likes, number of tweets  etc can determine trends over years",
    monthAnalysis:
      "Monthly analysis showing properties such as average likes, number of tweets  etc can determine trends within a partiucular year",
    interestOverTime:
      "Compare different user accounts in terms of their activity over time on social media to determine thier activity, likability etc",
    propertyBarYear:
      "Compare overall statistics such as average likes, number of tweets  etc for different sgements",
    dataPropertyScatter:
      "Forum data time series plot to see list of points of discussion in a date range.",
  },
  proposer: {
    heatMap:
      "Correlation between key proposer attributes and how they affect proposal funding outcomes. Numbers range between 1 and -1, with a higher number implying a relationship exists between attributes with a higher likelihood of being funded. The diagonal line of 1.00 across from top left to bottom right shows perfect correlation because each attribute matches with it's equivalent attribute on the opposite axis.",
    scatter:
      "Proposer Scatter Plot shows key attributes of proposals and their outcomes with adjustable axes and fixed bubble size. Click or hover over a bubble to find more detailed information at the proposer page.",
    bubble:
      "Proposer Bubble Plot shows key attributes of proposals and their outcomes with adjustable axes and the bubble property size. Click or hover over a bubble to find more detailed information at the proposer page.",
  },
  proposal: {
    count:
      "Bar Chart used for tallying the number of proposals which fall in a particular status category in each Fund. Status varies between funded and not funded, completed or not completed, approved, not approved, and overbudget.",
    scatter:
      "Scatter plot of proposals with important attributes to help understand where the boundary line is between being funded and not being funded.  Toggle the probability threshold to vary the decision boundary. See the definitions page for more details.",
    bubble:
      "Bubble plot enables a number of factors to be visualized and explored in various ways. Select the X-Y Axis property and adjust the Size Property to visualize the distribution of proposals with this particular attribute set. Click or hover on the bubble to learn more information about it.",
  },
  fund: {
    budget: "Fund budget progression over time",
    fundAvailability:
      "For each challenge, the budget depletion is visualized in red and shows it's depletion rate after each subsequent funded proposal is accounted for. The x-axis called ranking shows the proposals in order from highest to lowest amount of upvotes.",
    challengeAmount:
      "Pie chart showing the percentage of budget allocated to each challenge in a particular fund. Click or hover over a slice on the chart to see the dollar amount of budget allocation. Expand the image for greater visibility.",
  },
  minMaxAvg: {
    Amount: {
      fund: "Comparison between proposal amount requested statistics across different funds",
      challenge:
        "Comparison between proposal amount requested statistics across different challenges within a fund",
    },
    Rating: {
      fund: "Comparison of proposal ratings aggregated by average, minimum and maximum ratings across funds. The display groupings can be altered to compare funded, overbudget and not approved proposals. ",
      challenge:
        "Comparison between proposal rating statistics across different challenges within a fund",
    },
    Votes: {
      fund: "Comparison of number of votes and proposal funded status across funds. This shows general voting statistics of proposals at the fund level. ",
      challenge:
        "Comparison of number of votes and proposal funded status across challenges. This shows general voting statistics of proposals at the fund challenge.",
    },
    Proposal: {
      fund: "Number of proposals across Funds with different grouping status like funded, overbudget and not approved. Compare the amount of proposals that successfully received funding, received approval but were overbudget, or did not receive enough votes to be approved. ",
      challenge:
        "Compare the number of proposals across different challenges by a grouping status which varies from Funded to Overbudget and Not Approved. Click or hover over each bar to see the exact number.",
    },
  },
  variationOfFunds: {
    Amount: {
      fund: "Variation of the amounts requested within a fund, grouped by proposal statuses. This chart can show Fund level statistics based on different proposal statuses, like funded and not funded, completed and not completed, and more. See definitions page for more details.",
      challenge:
        "Variation of the amounts requested within a challenge, grouped by proposal statuses. This chart can show challenge level statistics based on different proposal statuses, like funded to completed, and more. See definitions page for more details.",
    },
    Rating: {
      fund: "Comparison of the range of ratings for proposals based on a particular funded status across all funds. Includes minimum, maximum, average and quartiles.",
      challenge:
        "Proposal rating variation across different challenges within a fund to understand the range of proposal ratings based on a particular funded and grouping status of the project.",
    },
    Votes: {
      fund: "Variation of voting results across different funds. Overview of how up votes, down votes, and differential of votes affected each fund.",
      challenge:
        "Variation of voting results across different challenges within a fund. Overview of how up votes, down votes, and differential of votes affected each challenge.",
    },
  },
};
